import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";

import TaskToolTip from "./taskToolTip";
import { getUnitPropertie } from "../../functions";

export default function TaskFieldImage(props) {
  const { label, fieldProperties, toolTip, style } = props;

  const variant = getUnitPropertie(fieldProperties, "variant");
  const align = getUnitPropertie(fieldProperties, "align");
  const url = getUnitPropertie(fieldProperties, "url");
  const width = getUnitPropertie(fieldProperties, "width");
  const height = getUnitPropertie(fieldProperties, "height");
  const widthProportion = getUnitPropertie(fieldProperties, "widthProportion");
  const heightProportion = getUnitPropertie(
    fieldProperties,
    "heightProportion",
  );

  const defineWidth = width || 300;
  const defineWidthProportion = widthProportion || "px";

  const defineHeight = height || 300;
  const defineHeightProportion = heightProportion || "px";

  const concatWidth = `${defineWidth}${defineWidthProportion}`;
  const concatHeight = `${defineHeight}${defineHeightProportion}`;

  return (
    <Grid
      container
      direction="row"
      justify={align || "center"}
      alignItems="center"
    >
      <TaskToolTip title={toolTip}>
        <figure>
          <img
            src={url}
            alt={label}
            style={{
              width: concatWidth,
              maxWidth: "100%",
              maxHeight: "100%",
              height: concatHeight,
            }}
          />
          <figcaption style={style}>
            <Typography variant={variant || undefined}>{label}</Typography>
          </figcaption>
        </figure>
      </TaskToolTip>
    </Grid>
  );
}
